module.exports = __webpack_public_path__ + "static/img/sdaqgl_xcaqgl_one.a4b9167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdaqgl_xcaqgl_one.png
// module id = TT5T
// module chunks = 21